import {PasswordLostAction} from './PasswordLostActions'
import {Loop} from '@mazechazer/redux-loop/lib'
import {
    PasswordLostInput,
    PasswordLostState,
    PasswordLostStatus,
    PasswordLostValidation
} from './PasswordLostState'
import * as Result from '../../Data/Result'
import {decodeHttpResponse, NetworkError, sendRequest} from '../../Data/Http'
import {update} from '../../Data/ObjectHelper'
import {
    emailValidator,
    mandatoryStringValidator,
    validateInputField
} from '../../Data/FormValidation'
import * as PasswordLostData from '../../Entities/PasswordLostData'
import * as PasswordLostResponse from '../../Entities/PasswordLostResponse'
import * as PasswordLostResource from '../../Request/PasswordLostResource'

export function initPasswordLostPage(): PasswordLostState {
    return {
        input: {
            email: '',
        },
        validation: {
            email: null,
        },
        submissionAttempted: false,
        status: {type: 'Pending'},
    }
}

export function passwordLostReducer(
    state: PasswordLostState,
    action: PasswordLostAction
): Loop<PasswordLostState,
    PasswordLostAction> {
    switch (action.type) {
        case 'EmailChanged':
            return {
                state: update({
                    input: update({
                        email: action.value,
                    }, state.input),
                    validation: update({
                        email: validateInputField(
                            validators.email,
                            state.submissionAttempted,
                            action.value),
                    }, state.validation),
                    status:
                        state.status.type === 'EmailNotFound' ?
                            {type: 'Pending'} :
                            state.status,
                }, state),
                effects: []
            }
        case 'Submit':
            const validationOutcome = validate(state.input)
            return (() => {
                switch (validationOutcome.type) {
                    case 'Ok':
                        return {
                            state: update({
                                submissionAttempted: false,
                                status: {type: 'Loading'},
                            }, state),
                            effects: [
                                sendRequest(
                                    (result: Result.Result<NetworkError, string>): PasswordLostAction => ({
                                        type: 'PasswordLostResponse',
                                        result,
                                    }),
                                    PasswordLostResource.submit(
                                        validationOutcome.value,
                                    ),
                                ),
                            ]
                        }
                    case 'Err':
                        return {
                            state: update({
                                validation: validationOutcome.error,
                                submissionAttempted: true,
                            }, state),
                            effects: []
                        }
                }
            })()
        case 'PasswordLostResponse': {
            const result =
                decodeHttpResponse(
                    PasswordLostResponse.decoder(),
                    action.result,
                )
            return {
                state: update({
                    status:
                        ((): PasswordLostStatus => {
                            switch (result.type) {
                                case 'Ok':
                                    return result.value
                                case 'Err':
                                    return {
                                        type: 'GeneralError',
                                        error: result.error,
                                    }
                            }
                        })(),
                }, state),
                effects: [],
            }
        }
    }
}

const validators = {
    email:
        (value: string) =>
            Result.andThen(
                emailValidator(),
                mandatoryStringValidator()(value)),

}

export function validate(
    input: PasswordLostInput,
): Result.Result<PasswordLostValidation, PasswordLostData.M> {
    const validationResults = {
        email: validators.email(input.email),
    }
    if (validationResults.email.type === 'Ok') {
        return {
            type: 'Ok',
            value: {
                email: validationResults.email.value,
            },
        }
    } else {
        return {
            type: 'Err',
            error: {
                email: Result.errorToNullable(validationResults.email),
            },
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/PasswordLost/PasswordLostReducer.ts